
export default {
  singleLabel: "Employé",
  storeNamespace: 'employee',
  authFeature: 'employee',
  listRouteName: "EmployeeList",
  newRouteName: "EmployeeNew",
  editRouteName: "EmployeeEdit",
  detailRouteName: "EmployeeDetail",
  useNewModal: true,
  useEditModal: true,
  formComponentName: 'EmployeeForm',
  hideActionCsvButton: true,
  hideActionPdfButton: true,
  titleField: 'number',
  sortBy: 'lastname',
  showExtendedFilters: true,
  fields: [
    {
      name: 'number',
      label: "Matricule",
      type: 'text',
      inForm: true,
      required: true,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: true,
      inFormCondition: (form) => form && form.is_import != 1,
    },
    {
      name: 'gaia_id',
      label: "GID",
      type: 'text',
      inForm: true,
      required: true,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: true,
      inFormCondition: (form) => form && form.is_import != 1,
    },
    {
      name: 'firstname',
      label: "Prénom",
      type: 'text',
      inForm: true,
      required: true,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: true,
      inFormCondition: (form) => form && form.is_import != 1,
    },
    {
      name: 'lastname',
      label: "Nom",
      type: 'text',
      inForm: true,
      required: true,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: true,
      inFormCondition: (form) => form && form.is_import != 1,
    },
    {
      name: 'agency_id',
      label: "Agence",
      type: 'chosen',
      inForm: true,
      required: true,
      inList: false,
      inDetail: false,
      inFormCondition: (form) => form && form.is_import != 1,
    },
    {
      name: 'agency',
      label: "Agence",
      type: 'chosen',
      inForm: false,
      inList: true,
      sortable: true,
      filterIn: false,
      extendedFilter: true,
      inDetail: true,
      detailLink: 'AgencyDetail',
      formatter: (context, value) => value && value.internal_number && value.name ? value.internal_number+" - "+value.name : null,
    },
    {
      name: 'user',
      label: "Compte utilisateur",
      type: 'text',
      inForm: false,
      inList: false,
      inDetail: true,
      detailLink: 'UserDetail',
      // Le lien employé <-> utilisateur est porté par `user.employee_id`, seul côté complet
      // des deux relations OneToOne existantes.
      formatter: (context, value) => {
        if (!value || !value.id) return null;
        const identite = [value.firstname, value.lastname].filter(Boolean).join(" ").trim();
        if (!identite) return value.email || null;
        return value.email ? identite + " — " + value.email : identite;
      }
    },
    {
      name: 'status',
      label: "Statut",
      type: 'select',
      inList: true,
      tabFilter: true,
      tabFilterDefaultValue: 'employee-active',
      key: 'status_slug',
      inDetail: true,
      formatter: (context, value) => value ? value.name : null
    },
    {
      name: 'status_slug',
      label: "Statut",
      type: 'select',
      inForm: true,
      required: true,
    },
    {
      name: 'release_date',
      label: "Date de sortie",
      type: 'date',
      inForm: true,
      inList: true,
      inDetail: true,
      inFormCondition: (form) => form && form.is_import != 1,
      formatter: (context, value) => value ? context.$moment(value).format("dddd, DD MMMM YYYY à H:mm") : null
    },
    {
      name: 'created_at',
      label: "Création",
      type: 'date',
      inForm: false,
      inList: false,
      inDetail: false,
      formatter: (context, value) => value ? context.$moment(value).format("dddd, DD MMMM YYYY à H:mm") : null
    },
    {
      name: 'updated_at',
      label: "Dernière modification",
      type: 'date',
      inForm: false,
      inList: false,
      inDetail: false,
      formatter: (context, value) => value ? context.$moment(value).format("dddd, DD MMMM YYYY à H:mm") : null
    },
    {
      name: 'rentings',
      label: "Commandes",
      type: 'text',
      inDetail: true,
    },
    {
      name: 'transfers',
      label: "Transferts",
      type: 'text',
      inDetail: true,
    },
  ]
}



// WEBPACK FOOTER //
// ./src/components/Employee/config.js